




















































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
import Util from '../../../lib/util'
import {SaveADialyWeight} from '../../../api/dialysisProcess'
import util from "../../../lib/util";

@Component({
     components:{multipleDataEchart}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    
    //表单值
    roleRule = {
        afterWeight:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        afterSbp:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        afterDbp:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
    }
    form:any = {
        patientId:this.data.patientId,
        afterWeight:null,
        afterSbp:null,
        afterDbp:null,
        afterHeartRate:null,
    }
    created() {
        // this.getPatBeforeDryWeightData()
    }
    
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                console.log(this.data)
                this.saveBDialyWeight(this.form)
            }
        })
    }
    async saveBDialyWeight(data:any){
        let res = await SaveADialyWeight(data)
        if(res.status == 1){
            // this.$Message.success('保存成功')
            this.$emit('input',false);
            this.$emit('on-success')
        }else{
            // this.$Message.error(res.message)
        }
    }

    mounted() {
       
    }
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/afterWeight.vue